import * as React from "react";
import HeroRichText from "@/ReactComponents/Hero/heroRichText/hero-rich-text";

const HeroRichTextView = props => <HeroRichText {...props} />;

export default HeroRichTextView;
